import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge"

// Register custom typography tokens (tailwind.config.js theme.fontSize) so
// tailwind-merge treats `text-label`, `text-body`… as font-size, not colour.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        { text: ["display", "h1", "h2", "h3", "title", "body-lg", "body", "body-sm", "caption", "label", "price-xl", "price"] },
      ],
    },
  },
});

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
